import { css } from "styled-components";

export const TextFieldStyles = css`
    //Size styles
    .FormControl.Sm {
        .TextField {
            height: 2.75rem;
        }
    }

    .FormControl.Md {
        .TextField {
            height: 3.75rem;
        }
    }

    .FormControl.Lg {
        .TextField {
            height: 4.5rem;
        }
    }
`;
